export default [
    {
        PER: 'WEEK',
        MULTIPLIER: 40
    },
    {
        PER: 'BI-WEEKLY',
        MULTIPLIER: 80
    },
    {
        PER: 'MONTH',
        MULTIPLIER: 173.3337931
    },
    {
        PER: 'YEAR',
        MULTIPLIER: 2080
    },
]